import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { CSSProperties, ReactElement } from 'react';
import styled from 'styled-components';

const AnalyticsElementContainer = styled(Grid)`
  width: 100%;
  display: flex;
  flex-direction: column !important;
  padding: 20px;
  border-radius: 10px;
  background-color: ${RoutalPalette.neutral02n};
  box-shadow: 0px 0px 8px 4px rgba(125, 154, 150, 0.15);
`;

const AnalyticsElementHeader = styled(Grid)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 20px 0;
  height: 60px;
  border-bottom: 1px solid ${RoutalPalette.neutral10};
`;

const AnalyticsElementContent = styled(Grid)`
  display: flex;
  width: 100%;
  height: 100%;
`;

interface AnalyticsElementProps {
  containerStyle?: CSSProperties;
  headerStyle?: CSSProperties;
  header: ReactElement;
  contentStyle?: CSSProperties;
  content: ReactElement;
}

export const AnalyticsElement = ({
  containerStyle,
  headerStyle,
  header,
  contentStyle,
  content,
}: AnalyticsElementProps) => {
  return (
    <AnalyticsElementContainer style={{ ...containerStyle }}>
      <AnalyticsElementHeader style={{ ...headerStyle }}>{header}</AnalyticsElementHeader>
      <VSpacer medium />
      <AnalyticsElementContent style={{ ...contentStyle }}>{content}</AnalyticsElementContent>
    </AnalyticsElementContainer>
  );
};
